export enum AuthRoleIdEnum {
  ADMIN = 1,
  COACH = 2,
  PLAYER = 3,
  OWNER = 4
}

export enum AuthRoleNameEnum {
  ADMIN = 'Admin',
  COACH = 'Coach',
  PLAYER = 'Player',
  OWNER = 'Owner'
}

export enum EQualityOfSearchFeature {
  GOOD = 'good',
  BAD = 'bad'
}
